<!-- eslint-disable vue/multiline-html-element-content-newline -->

<template>
  <component
    :is="component"
    :class="b({ view, checked, disabled })"
    :disabled="disabled"
    ><slot
  /></component>
</template>

<script src="./action.scripts.js" />

<style module src="./action.styles.scss" lang="scss" />
